export enum NotificationSeverity {
  Info,
  Success,
  Warning,
  Error
}
